import React, { Component } from 'react';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as Search from 'searchtabular';
import {
  Glyphicon,
  OverlayTrigger,
  Tooltip,
  Button,
  PageHeader,
  Grid,
  Row,
  Col,
  Pagination,
} from 'react-bootstrap';
import { orderBy, map } from 'lodash';
import {
  getAccessorialRates,
  removeAccessorialRate,
} from 'utils/AccessorialRatesAPIUtils';
import AccessorialRatesEditModal from './AccessorialRatesEditModal';
import { updateContract } from 'utils/ContractsAPIUtils';
import paginate from 'utils/pagination-util';
import Store from 'stores/AccessorialRatesStore';

export default class AccessorialRatesList extends Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};
    const sortable = sort.sort({
      getSortingColumns,
      onSort: (selectedColumn) => {
        this.setState({
          sortingColumns: sort.byColumns({
            // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn,
          }),
        });
      },
    });
    this.state = {
      editedCell: null,
      accessorialRates: [],
      query: {},
      searchColumn: 'all',
      sortingColumns: null,
      showEditor: false,
      columns: [
        {
          property: 'name',
          header: {
            label: 'Name',
            formatters: [
              sort.header({
                sortable,
                getSortingColumns,
                strategy: sort.strategies.byProperty,
              }),
            ],
          },
          cell: {
            formatters: [Search.highlightCell],
          },
        },
        {
          property: 'type',
          header: {
            label: 'Type',
            formatters: [
              sort.header({
                sortable,
                getSortingColumns,
                strategy: sort.strategies.byProperty,
              }),
            ],
          },
          cell: {
            formatters: [Search.highlightCell],
          },
        },
        {
          property: 'description',
          header: {
            label: 'Description',
            formatters: [
              sort.header({
                sortable,
                getSortingColumns,
                strategy: sort.strategies.byProperty,
              }),
            ],
          },
          cell: {
            formatters: [Search.highlightCell],
          },
        },
        {
          header: {
            formatters: [
              () => (
                <Button
                  bsSize="xsmall"
                  className="btn btn-default"
                  onClick={this.newAccessorialRate()}
                >
                  New Accessorial Rates
                </Button>
              ),
            ],
          },
          cell: {
            formatters: [
              (value, { rowData }) => {
                const accessorialRate = rowData;

                const remove = (password) => {
                  this.handleAccessorialRateDelete(accessorialRate, password);
                };

                const edit = () => {
                  this.setState({
                    showEditor: true,
                    accessorialRate: accessorialRate,
                  });
                };

                return (
                  <span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="remove">Remove</Tooltip>}
                    >
                      <Glyphicon
                        glyph="remove"
                        style={{ cursor: 'pointer', color: 'red' }}
                        onClick={remove}
                      />
                    </OverlayTrigger>
                    &nbsp;
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="edit">Edit</Tooltip>}
                    >
                      <Glyphicon
                        glyph="edit"
                        style={{ cursor: 'pointer', color: 'green' }}
                        onClick={edit}
                      />
                    </OverlayTrigger>
                  </span>
                );
              },
            ],
          },
        },
      ],
      pagination: {
        page: 0,
        perPage: 10,
      },
    };
    this.onChange = () => this.onStoreChange();
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
    if (this.props.contract._id) {
      getAccessorialRates(this.props.contract._id);
    } else {
      Store.clearAll();
    }
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onStoreChange() {
    this.setState({ accessorialRates: Store.getAccessorialRates() }, () => {
      if (Store.getIsAddOrRemove()) {
        const contract = this.props.contract;
        if (contract) {
          contract.accessorial_rates = map(Store.getAccessorialRates(), '_id');
          updateContract(contract);
        }
        Store.setIsAddOrRemove();
      }
    });
  }

  onSearch(search) {
    this.setState({
      editedCell: null,
      search: search,
    });
  }

  newAccessorialRate() {
    return () => {
      this.setState({ showEditor: true });
    };
  }

  handleAccessorialRateDelete(accessorialRate, password) {
    if (accessorialRate) {
      Store.reset();
      removeAccessorialRate(accessorialRate, password);
    }
  }

  onPerPage = (e) => {
    const pagination = this.state.pagination || {};
    pagination.perPage = parseInt(e.target.value, 10);
    this.setState({ pagination: pagination });
  };

  onSelect(eventKey) {
    const pagination = this.state.pagination || {};
    pagination.page = eventKey - 1;
    this.setState({ pagination: pagination });
  }

  render() {
    let accessorialRates = this.state.accessorialRates;
    const columns = this.state.columns;
    const searchColumn = this.state.searchColumn;
    const pagination = this.state.pagination;
    const query = this.state.query;
    const sortingColumns = this.state.sortingColumns;
    const showEditor = this.state.showEditor;
    if (accessorialRates && query) {
      accessorialRates = Search.highlighter({
        columns: columns,
        matches: Search.matches,
        query,
      })(Search.multipleColumns({ columns, query })(accessorialRates));
    }
    accessorialRates = sort.sorter({
      columns: columns,
      sortingColumns,
      sort: orderBy,
    })(accessorialRates);
    let totalPages = 0;
    if (pagination.perPage && accessorialRates) {
      totalPages = Math.ceil(accessorialRates.length / pagination.perPage);
    }

    const accessorialRate = this.state.accessorialRate;
    const paginated = paginate(accessorialRates, pagination);
    const close = () => {
      this.setState({ showEditor: false, accessorialRate: null });
    };
    let modal = <div />;
    if (showEditor) {
      modal = (
        <AccessorialRatesEditModal
          className="contract-wrapper"
          accessorialRate={accessorialRate}
          onClose={close}
          show
        />
      );
    }
    return (
      <div className="contract-wrapper">
        <PageHeader>AccessorialRates</PageHeader>
        <Grid fluid>
          <Row className="show-grid row-centered">
            <Col xs={4} className="fixed col-left">
              <label>
                Per page{' '}
                <input
                  type="number"
                  defaultValue={pagination.perPage}
                  onChange={this.onPerPage}
                />
              </label>
            </Col>
            <Col xs={4} className="col-centered">
              <h4>{`Page ${pagination.page + 1} of ${totalPages}`}</h4>
            </Col>
            <Col xs={4} className="col-right">
              <div className="search-container">
                <span>Search</span>
                <Search.Field
                  column={searchColumn}
                  query={query}
                  columns={columns}
                  rows={paginated.data}
                  onColumnChange={(searchColumn) =>
                    this.setState({ searchColumn })
                  }
                  onChange={(query) => this.setState({ query })}
                />
              </div>
            </Col>
          </Row>
        </Grid>
        <div>
          <Table.Provider className="default-table" columns={columns}>
            <Table.Header />
            <Table.Body rows={paginated.data} rowKey="_id" />
          </Table.Provider>
        </div>
        <div className="controls">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            items={paginated.amount}
            maxButtons={5}
            activePage={pagination.page + 1}
            onSelect={(eventKey) => this.onSelect(eventKey)}
          />
        </div>
        <div>{modal}</div>
      </div>
    );
  }
}
